import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-sso-enabled.component.less'],
  templateUrl: './tellent-sso-enabled.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentSsoEnabledTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentSsoEnabledTemplateData>;
}

export type TellentSsoEnabledTemplateData = {
  title: string;
  p1: string;
  avatar_url: string;
  p2: string;
  url: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
};

export const TellentSsoEnabledTemplateMocks: TellentSsoEnabledTemplateData[] = [
  {
    title: 'SSO Enabled 🔑',
    p1: 'Tellent owner has enabled single sing-on (SSO) for %{company_name}.',
    avatar_url:
      'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
    p2: 'Password login is no longer possible. Use the URL below to sign in with SSO.',
    url: 'https://auth.recruitee.com/sso/sign-in/%{company_name}',
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
  },
];
